import { Margin, PageSubtitle, PageTitle } from "../../widgets/small-widgets";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { decimalRegex } from "../../utils/regex";
import FormTextField from "../../widgets/textFields";
import theme from "../../style/theme";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { esES, caES } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/es';
import 'dayjs/locale/ca';
import { ThemeProvider } from "@emotion/react";
import { Autocomplete, Button, TextField } from "@mui/material";
import { stateOptions } from "../../utils/state-opt";
import { SearchOutlined } from "@mui/icons-material";
import { searchPaymentIntent } from "../../classes/stripe/functions/paymentIntent.tsx";
import { isValidDate } from "../../classes/utils/dateTime.tsx";
import { OverviewLoadingTable, OverviewTable } from "../../widgets/balance/tables.jsx";

export default function BalancePage() {
    const { t, i18n } = useTranslation();

    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);

    const [loading, setLoading] = useState(false);
    const [payments, setPayments] = useState(null);
    const [hasMore, setHasMore] = useState(null);
    const [nextPage, setNextPage] = useState(null);

    async function getPayments(search) {
        setLoading(true);

        console.log(document.getElementById('minDate')?.value);

        const minAmount = parseFloat(document.getElementById('minAmount')?.value);
        const maxAmount = parseFloat(document.getElementById('maxAmount')?.value);
        const state = stateOptions(t).indexOf(document.getElementById('state')?.value);

        console.log(minAmount, maxAmount, minDate, maxDate, state);

        const result = await searchPaymentIntent(!isNaN(minAmount) ? minAmount : null, !isNaN(maxAmount) ? maxAmount : null, isValidDate(minDate) ? minDate : null, isValidDate(maxDate) ? maxDate : null, state !== -1 ? state : null, search ? null : nextPage);

        console.log(result);
        if (result.getError() === null) {
            if (search) {
                setPayments(result.getPaymentIntents());
            } else {
                setPayments(payments.concat(result.getPaymentIntents()));
            }

            setHasMore(result.getHasMore());
            setNextPage(result.getNextPage());
        } else {
            //TODO: show error
        }
        
        setLoading(false);
    }

    return <div style={{padding: '1.2rem'}}>
        <PageTitle>{t('navigation.balancePage')}</PageTitle>
        <form noValidate onSubmit={(e) => {
            e.preventDefault();

            getPayments(true);
        }}>
            <ThemeProvider theme={theme}>
                <Margin height={15}/>
                <p className="no-margin soft-black" style={{color: theme.palette.secondary.dark}}>{t('balance.filter.amount.title')}</p>
                <div style={{display: 'flex', gap: '10px'}}>
                    <FormTextField id="minAmount" label={t('balance.filter.amount.min')} regex={decimalRegex} type="number" errorMsg={t('balance.filter.amount.error')} adornment="€" adornmentPosition="start" numberMin={0.01}/>
                    <FormTextField id="maxAmount" label={t('balance.filter.amount.max')} regex={decimalRegex} type="number" errorMsg={t('balance.filter.amount.error')} adornment="€" adornmentPosition="start" numberMin={0.01}/>
                </div>
                <Margin height={15}/>
                <p className="no-margin soft-black" style={{color: theme.palette.secondary.dark}}>{t('balance.filter.date.title')}</p>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n.resolvedLanguage??'es'} localeText={i18n.resolvedLanguage??'es' === 'ca' ? caES.components.MuiLocalizationProvider.defaultProps.localeText : esES.components.MuiLocalizationProvider.defaultProps.localeText}>
                    <div style={{display: 'flex', gap: '10px'}}>
                        <DatePicker sx={{margin: '8px', width: '100%'}} format="DD/MM/YYYY" label={t('balance.filter.date.min')} onChange={(newVal) => {console.log(newVal.toDate()); setMinDate(newVal.toDate());}}/>
                        <DatePicker sx={{margin: '8px', width: '100%'}} format="DD/MM/YYYY" label={t('balance.filter.date.max')} onChange={(newVal) => {console.log(newVal.toDate()); setMaxDate(newVal.toDate());}}/>
                    </div>
                </LocalizationProvider>
                <Margin height={15}/>
                <p className="no-margin soft-black" style={{color: theme.palette.secondary.dark}}>{t('balance.filter.state.title')}</p>
                <div style={{display: 'flex', gap: '10px'}}>
                    <Autocomplete
                        id="state"
                        disablePortal
                        options={stateOptions(t)}
                        sx={{ width: '100%', margin: '8px' }}
                        renderInput={(params) => <TextField {...params} label={t('balance.filter.state.title')} variant="outlined"/>}
                    />
                    <div style={{width:'100%', margin:'8px'}}>
                        <Button variant="contained" sx={{ width:'100%', height: '100%', fontWeight: 'bold' }} endIcon={<SearchOutlined/>} type="submit">{t('balance.filter.search')}</Button>
                    </div>
                </div>
            </ThemeProvider>
        </form>
        <Margin height={25}/>
        {loading === true
            ? <OverviewLoadingTable rows={20}/>
            : payments === null || payments === undefined
                ? null
                : payments.length === 0
                    ? <div style={{width: '100%', textAlign: 'center'}}>
                        <PageSubtitle>{t('balance.filter.noResults')}</PageSubtitle>
                    </div>
                    : <>
                        <OverviewTable balances={payments}/>
                        {hasMore === true
                            ? <ThemeProvider theme={theme}>
                                <div style={{padding: '0 5px'}}><Button variant="contained" sx={{ width:'100%', height: '100%', fontWeight: 'bold', borderRadius: '0 0 4px 4px' }} onClick={() => {
                                    getPayments(false);
                                }}>{t('balance.tables.loadMore')}</Button></div>
                            </ThemeProvider> : null
                        }
                    </>
        }
    </div>;
}